<template>
  <div class="outerbox">
    <table class="resultTable2">
      <tbody>
        <tr>
          <td class="resultdamacailable" style="width: 20%">
            <img
              src="/images/lottery/icon_superj3-logo.png"
              width="50"
              height="38"
            />
          </td>
          <td class="resultdamacailable">Super J3 (3PM)</td>
          <td class="resultdamacailable">
            <i
              id="dlive"
              class="fa fa-soccer-ball-o fa-spin fa-fw"
              style="display: none"
              aria-hidden="true"
              title="Live Draw"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <table class="resultTable2">
      <tbody>
        <tr>
          <td class="resultdrawdate" id="ddd">
            Date: {{ formatDate(mktData.date) }}
          </td>
        </tr>
      </tbody>
    </table>

    <table class="resultTable2">
      <tbody>
        <tr>
          <td class="resultprizelable">1st Prize</td>
          <td class="resultprizelable">2nd Prize</td>
          <td class="resultprizelable">3rd Prize</td>
        </tr>
        <tr>
          <td class="resulttop">
            {{ getSpecialGrandPrizeNumber(1) }}
          </td>
          <td class="resulttop">
            {{ getSpecialGrandPrizeNumber(2) }}
          </td>
          <td class="resulttop">
            {{ getSpecialGrandPrizeNumber(3) }}
          </td>
        </tr>
      </tbody>
    </table>

    <table class="resultTable2">
      <tbody>
        <tr>
          <td colspan="5" class="resultprizelable">Special</td>
        </tr>
        <tr>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(1) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(2) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(3) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(4) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(5) }}
          </td>
        </tr>
        <tr>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(6) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(7) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(8) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(9) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(10) }}
          </td>
        </tr>
        <tr>
          <td class="resultbottom" id="ds1"></td>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(11) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(12) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getSpecialPrizeNumber(13) }}
          </td>
          <td class="resultbottom" id="ds1"></td>
        </tr>
      </tbody>
    </table>

    <table class="resultTable2">
      <tbody>
        <tr>
          <td colspan="4" class="resultprizelable">Consolation</td>
        </tr>
        <tr>
          <td class="resultbottom" id="ds1">
            {{ getConsolationPrizeNumber(1) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getConsolationPrizeNumber(2) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getConsolationPrizeNumber(3) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getConsolationPrizeNumber(4) }}
          </td>
        </tr>
        <tr>
          <td class="resultbottom" id="ds1">
            {{ getConsolationPrizeNumber(5) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getConsolationPrizeNumber(6) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getConsolationPrizeNumber(7) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getConsolationPrizeNumber(8) }}
          </td>
        </tr>
        <tr>
          <td class="resultbottom" id="ds1"></td>
          <td class="resultbottom" id="ds1">
            {{ getConsolationPrizeNumber(9) }}
          </td>
          <td class="resultbottom" id="ds1">
            {{ getConsolationPrizeNumber(10) }}
          </td>

          <td class="resultbottom" id="ds1"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    mktData: {
      required: true,
      default: {},
    },
  },
  methods: {
    showData(value, append = "", prepend = "") {
      if (value == "" || value == undefined || value == null) {
        return "----";
      } else if (value.toString().includes("script")) {
        return `${append}${parseInt(
          value.toString().match(/\d+/)[0]
        )}${prepend}`;
      } else {
        return `${append}${value}${prepend}`;
      }
    },
    formatDate(date) {
      let formmattedDate = moment(date);

      return formmattedDate.format("YYYY-MM-DD");
    },
    getSpecialGrandPrizeNumber(position) {
      return (
        this.mktData.special.find((x) => x.prize == position)?.number ?? "-"
      );
    },
    getSpecialPrizeNumber(position) {
      let specialPriceTopThree = [
        this.mktData?.special?.find((x) => x.prize == 1)?.number,
        this.mktData?.special?.find((x) => x.prize == 2)?.number,
        this.mktData?.special?.find((x) => x.prize == 3)?.number,
      ];
      let theNumber =
        this.mktData?.special?.find((x) => x.position == position)?.number ??
        "-";

      if (specialPriceTopThree.includes(theNumber)) {
        return "-";
      } else return theNumber;
    },
    getConsolationPrizeNumber(position) {
      let consolationPriceTopThree = [
        this.mktData?.consolation?.find((x) => x.prize == 1)?.number,
        this.mktData?.consolation?.find((x) => x.prize == 2)?.number,
        this.mktData?.consolation?.find((x) => x.prize == 3)?.number,
      ];
      let theNumber =
        this.mktData?.consolation?.find((x) => x.position == position)
          ?.number ?? "-";

      if (consolationPriceTopThree.includes(theNumber)) {
        return "-";
      } else return theNumber;
    },
  },
};
</script>

<style scoped>
.outerbox {
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  border: #b4b4b4 1px solid;
  vertical-align: top;
  -moz-box-shadow: 0 0 2px 1px #ddd;
  -webkit-box-shadow: 0 0 2px 1px #ddd;
  box-shadow: 0 0 2px 1px #ddd;

  background-color: #fff;
  text-align: center;
  padding: 5px;
}

.resultTable2 {
  width: 100%;
  margin: 3px 0;
  padding: 0;
}
.resultm4dlable {
  background-color: #ff0;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #444;
  height: 26px;
}

.resultdamacailable {
  background-color: #db3832;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  height: 26px;
}

.resultgdlottolable {
  background-color: #e81409;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  height: 26px;
}

.resulttotolable {
  background-color: #ad0006;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  height: 26px;
}

.resultprizelable {
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  background-color: #333;
  color: #fff;
  min-height: 25px;
  vertical-align: middle;
  padding: 5px 0;
  border-color: #333;
  border-style: solid;
  border-width: 1px;
}

.resultdrawdate {
  text-align: left;
  font-size: 14px;
  color: #333;
  padding: 5px 0;
  vertical-align: middle;
}

.resultbottom {
  text-align: center;
  font-size: 24px;
  color: #000;
  width: 20%;
  border-color: #ccc;
  border-style: solid;
  border-width: 1px;
  padding: 3px 0;
  height: 36px;
}

.jackpot-detail-box {
  height: auto;
  position: relative;
  margin-top: 180px;
}

@media (max-width: 959px) {
  .jackpot-detail-box {
    margin-top: 190px;
  }
}
@media (max-width: 599px) {
  .jackpot-detail-box {
    margin-top: 150px;
  }
}

.resulttop {
  font-size: 28px;
  color: #303030;
  font-weight: 700;
  text-align: center;
  border-color: #ccc;
  border-style: solid;
  border-width: 1px;
  padding: 2px 0;
  height: 40px;
}

@media (max-width: 500px) {
  .resulttop {
    font-size: 22px;
  }

  .resultbottom {
    font-size: 18px;
  }
}
</style>
